import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Business = {
  id: string | null;
  name: string | null;
};

export type BusinessNetworkPayload = {
  id: string;
  name: string;
  canEditBusinessName?: boolean;
  path?: string | undefined;
};

export type BusinessNetworkState = {
  open: boolean;
  hasBuro: boolean;
  hasSuperDebt: boolean;
  business: Business;
  canEditBusinessName: boolean;
  refreshTrigger: number;
  lastRefresh: number;
  path?: string | undefined;
};

const initialState: BusinessNetworkState = {
  open: false,
  business: { id: null, name: null } as Business,
  hasBuro: false,
  hasSuperDebt: false,
  canEditBusinessName: false,
  refreshTrigger: 0,
  lastRefresh: 0,
  path: undefined,
};

const businessNetworkSlice = createSlice({
  name: 'businessNetwork',
  initialState,
  reducers: {
    showBusinessNetwork: (
      state,
      action: PayloadAction<BusinessNetworkPayload>,
    ) => {
      state.open = true;
      state.business = { id: action.payload.id, name: action.payload.name };
      state.canEditBusinessName = action.payload.canEditBusinessName || false;
      state.path = action.payload.path;
    },
    hideBusinessNetwork: (state) => {
      state.open = false;
      state.business = { id: null, name: null };
      state.canEditBusinessName = false;
      state.path = undefined;
    },
    setHasSuperDebt: (state, action: PayloadAction<boolean>) => {
      state.hasSuperDebt = action.payload;
    },
    setHasBuro: (state, action: PayloadAction<boolean>) => {
      state.hasBuro = action.payload;
    },
    triggerRefresh: (state) => {
      state.refreshTrigger += 1;
      state.lastRefresh = Date.now();
    },
  },
});

export const {
  showBusinessNetwork,
  hideBusinessNetwork,
  setHasSuperDebt,
  setHasBuro,
  triggerRefresh,
} = businessNetworkSlice.actions;
export default businessNetworkSlice.reducer;
